import { Component, Injector, Input, OnInit } from '@angular/core';
import { Facturacion } from '../../Models/facturacion';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Poliza } from 'src/app/Models/poliza';
import { AppInsightsService } from 'src/app/Services/appInsight.service';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { Seguro } from 'src/app/Models/seguro';

@Component({
  selector: 'app-mes-gastado',
  templateUrl: './mes-gastado.component.html',
  styleUrls: ['./mes-gastado.component.css']
})

export class MesGastadoComponent implements OnInit {

  @Input()
  facturacion: Facturacion;
  @Input()
  poliza: Poliza;
  asegurado: Asegurado;

  constructor(private modalService: NgbModal, private inj: Injector) { }

  ngOnInit(): void {
  }

  open(content: any): void{
    this.asegurado = JSON.parse(localStorage.getItem('asegurado'));
    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Datos del modal como se calcula este precio: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.poliza.patente}, Nombre del Seguro: ${this.poliza.producto}, Fecha Hora: ${fechaHoy.toString()})`);
    this.modalService.open(content, {ariaLabelledBy: 'modalCotizacion', backdropClass: 'in'}).result.then((result) => {
    });
  }

}
